import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray"; // @flow

import { useEffect } from 'react';
/*::
  import { type ElementType, type ElementRef } from 'react';

  type ReactObjRef<ElementType: ElementType> = {
    current: null | ElementRef<ElementType>
  }

  type Callback = (event: MouseEvent) => void;
*/

/**
 * Runs callback() when clicked outside of ref element
 */

export var useClickOutsideCallback = function useClickOutsideCallback(ref
/*: ReactObjRef<any> */
, callback
/*: Callback */
, dependencies
/*: mixed[] */
) {
  if (dependencies === void 0) {
    dependencies = [];
  }

  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event
    /*: MouseEvent */
    ) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback(event);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref].concat(_toConsumableArray(dependencies)));
};